/*
 * assets/cart-upsell.js
 * Native Interaktion für die Cart-Notification (Gewinner-Upsell).
 * FB-Erweiterung: Bundle-Items (Line-Item-Property „Waschgänge“ bzw. data-washper an der Karte)
 * zeigen bei Mengenänderungen „Menge × Waschgänge/Stück Waschgänge“ statt pauschal „Menge × 80 Spülgänge“.
 * Preise werden als ZEILENPREIS (Menge × Stück) angezeigt und bei Mengenänderung aktualisiert.
 */
(function () {
  'use strict';

  var R = window.routes || {};
  var ROOT = R.root_url && R.root_url !== '/' ? R.root_url.replace(/\/$/, '') : '';
  var CHANGE_URL = R.cart_change_url || '/cart/change';
  var ADD_URL = R.cart_add_url || '/cart/add';
  var CART_URL = R.cart_url || '/cart';
  var WASH_PER_UNIT = 80;
  var SECTIONS = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
  var COUNT_SECTIONS = ['cart-notification-button', 'cart-icon-bubble'];

  var inflight = false;
  var pending = null;
  function schedule(task) {
    if (inflight) { pending = task; return; }
    inflight = true;
    Promise.resolve().then(task)
      .catch(function (e) { console.error('[cart-upsell]', e); })
      .finally(function () {
        inflight = false;
        var next = pending; pending = null;
        if (next) schedule(next);
      });
  }

  function getNotification() { return document.querySelector('cart-notification'); }
  function pinHeader() { document.documentElement.classList.add('fri-cart-open'); }

  function syncCartTop() {
    var sec = document.querySelector('.section-header');
    var note = document.getElementById('cart-notification');
    if (!sec || !note) return;
    var b = sec.getBoundingClientRect().bottom;
    if (b < 0) b = 0;
    note.style.setProperty('--fri-cart-top', Math.round(b) + 'px');
  }
  function scheduleCartTop() {
    syncCartTop();
    requestAnimationFrame(syncCartTop);
    setTimeout(syncCartTop, 360);
  }

  function scrollCartToTop() {
    requestAnimationFrame(function () {
      var note = document.getElementById('cart-notification');
      if (note) note.scrollTop = 0;
      var prod = document.getElementById('cart-notification-product');
      if (prod) prod.scrollTop = 0;
    });
  }

  function syncOpenState() {
    var note = document.getElementById('cart-notification');
    var open = !!(note && note.classList.contains('active'));
    document.documentElement.classList.toggle('fri-cart-open', open);
    if (open) scheduleCartTop();
  }

  function openLayout() { pinHeader(); scheduleCartTop(); }

  function openNotification() {
    openLayout();
    var n = getNotification();
    if (!n) return;
    if (typeof n.open === 'function') { try { n.open(); return; } catch (e) {} }
    var inner = document.getElementById('cart-notification');
    if (inner) { inner.classList.add('animate', 'active'); inner.removeAttribute('aria-hidden'); }
  }

  function sectionInner(html, sectionId) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var wrap = doc.getElementById('shopify-section-' + sectionId)
      || doc.querySelector('.shopify-section')
      || doc.getElementById(sectionId)
      || doc.body;
    return wrap ? wrap.innerHTML : '';
  }

  function applySections(sections) {
    if (!sections) return;
    var prod = document.getElementById('cart-notification-product');
    if (prod && sections['cart-notification-product'] != null) {
      prod.innerHTML = sectionInner(sections['cart-notification-product'], 'cart-notification-product');
    }
    var btn = document.getElementById('cart-notification-button');
    if (btn && sections['cart-notification-button'] != null) {
      btn.innerHTML = sectionInner(sections['cart-notification-button'], 'cart-notification-button');
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble'] != null) {
      bubble.innerHTML = sectionInner(sections['cart-icon-bubble'], 'cart-icon-bubble');
    }
  }

  function eur(cents) {
    return '€' + (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function priceHTML(item) {
    var qty = item.quantity || 1;
    var orig = (item.original_line_price != null) ? item.original_line_price : (item.original_price * qty);
    var fin = (item.final_line_price != null) ? item.final_line_price : (item.final_price * qty);
    if (orig > fin) {
      var pct = Math.round((orig - fin) * 100 / orig);
      return '<div class="FRI-66__product-card-price-wrapper"><span class="FRI-66__product-card-price-original">' + eur(orig) + '</span><span class="FRI-66__product-card-price-text">' + eur(fin) + '</span></div><p class="FRI-66__product-card-discounted-percentage">-' + pct + '%</p>';
    }
    return '<div class="FRI-66__product-card-price-wrapper"><span class="FRI-66__product-card-price-text">' + eur(fin) + '</span></div>';
  }
  // FB: Waschgänge pro Stück aus Karte (data-washper) oder Cart-Item-Property „Waschgänge“
  function washPerFor(card, item) {
    if (item && item.properties) {
      for (var k in item.properties) {
        if (Object.prototype.hasOwnProperty.call(item.properties, k) && k.toLowerCase().indexOf('waschg') === 0) {
          var v = parseFloat(item.properties[k]);
          if (v > 0) return v;
        }
      }
    }
    if (card) {
      var a = parseFloat(card.getAttribute('data-washper') || '');
      if (a > 0) return a;
    }
    return 0;
  }
  // Subline-Text: Bundles -> "{Menge x Waschgänge/Stück} Waschgänge", sonst "{Menge x 80} Spülgänge"
  function washText(qty, washPer) {
    if (washPer > 0) { return (qty * washPer) + ' Waschgänge'; }
    return (qty * WASH_PER_UNIT) + ' Spülgänge';
  }
  // Aktualisiert die Warenkorb-Karten in-place aus der Cart-Antwort (Key, Menge, Spülgänge, Preis/Rabatt)
  function syncCardsFromCart(items) {
    if (!items) return;
    var cards = document.querySelectorAll('#cart-notification-product .FRI-66__product-card');
    for (var i = 0; i < cards.length && i < items.length; i++) {
      var it = items[i], card = cards[i];
      if (!it || !card) continue;
      if (it.key) card.setAttribute('data-key', it.key);
      var washEl = card.querySelector('.FRI-66__product-card-wash');
      if (washEl) washEl.textContent = washText(it.quantity, washPerFor(card, it));
      var priceEl = card.querySelector('.FRI-66__product-card-price');
      if (priceEl) priceEl.innerHTML = priceHTML(it);
      var input = card.querySelector('.FRI-66__product-card-quantity-input');
      if (input && document.activeElement !== input) { input.value = it.quantity; input.setAttribute('value', it.quantity); }
    }
  }
  // Entprellter Nach-Sync per /cart.js (fängt verzögerte Rabatte ab, ohne Request-Stapel)
  var refetchTimer = null;
  function refetchCartAndSync(delay) {
    if (refetchTimer) clearTimeout(refetchTimer);
    refetchTimer = setTimeout(function () {
      refetchTimer = null;
      fetch(ROOT + '/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { syncCardsFromCart(cart.items); })
        .catch(function () {});
    }, delay || 500);
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // Karte per Line-Item-Key bzw. Zeilennummer finden (fuer Revert/Feedback)
  function findCard(key, line) {
    var root = document.getElementById('cart-notification-product');
    if (!root) return null;
    if (key) { var c = root.querySelector('.FRI-66__product-card[data-key="' + key + '"]'); if (c) return c; }
    if (line) return root.querySelector('.FRI-66__product-card[data-line="' + parseInt(line, 10) + '"]');
    return null;
  }
  // Kurzes visuelles Feedback, wenn die Menge wegen Bestand nicht erhoeht werden kann
  function flashLimit(card) {
    if (!card) return;
    var h = card.querySelector('.FRI-66__product-card-quanity-handler');
    if (!h) return;
    h.style.transition = 'box-shadow .15s ease';
    h.style.boxShadow = '0 0 0 2px rgba(226,64,34,.45)';
    setTimeout(function () { h.style.boxShadow = 'none'; }, 700);
  }
  // Bei abgelehnter Aenderung (z.B. 422 Verfuegbarkeit): echten Cart-Stand wiederherstellen
  function reconcileFromCart(flashCard) {
    return fetch(ROOT + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cards = document.querySelectorAll('#cart-notification-product .FRI-66__product-card');
        for (var i = 0; i < cards.length && i < cart.items.length; i++) {
          var it = cart.items[i], card = cards[i];
          if (!it || !card) continue;
          var input = card.querySelector('.FRI-66__product-card-quantity-input');
          if (input) { input.value = it.quantity; input.setAttribute('value', it.quantity); }
          var washEl = card.querySelector('.FRI-66__product-card-wash');
          if (washEl) washEl.textContent = washText(it.quantity, washPerFor(card, it));
          var priceEl = card.querySelector('.FRI-66__product-card-price');
          if (priceEl) priceEl.innerHTML = priceHTML(it);
        }
        if (flashCard) flashLimit(flashCard);
      })
      .catch(function () {});
  }

  function changeItem(key, line, quantity, qtyOnly) {
    schedule(function () {
      var secs = qtyOnly ? COUNT_SECTIONS : SECTIONS;
      var body = { quantity: quantity, sections: secs, sections_url: window.location.pathname };
      if (key) { body.id = key; } else if (line) { body.line = parseInt(line, 10); } else { return; }
      return fetch(CHANGE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
        .then(function (res) {
          if (res.ok && res.data && !res.data.errors) {
            applySections(res.data.sections);
            if (qtyOnly && res.data.items) { syncCardsFromCart(res.data.items); refetchCartAndSync(600); }
          } else {
            // Bestandslimit / Verfuegbarkeit -> Menge laesst sich nicht erhoehen: echten Stand zuruecksetzen
            return reconcileFromCart(findCard(key, line));
          }
        });
    });
  }

  function addVariant(variantId, quantity) {
    schedule(function () {
      var item = { id: variantId, quantity: quantity };
      return postJSON(ADD_URL, { items: [item], sections: SECTIONS, sections_url: window.location.pathname })
        .then(function (state) {
          if (state && state.status) { return; }
          applySections(state.sections); openNotification(); scrollCartToTop();
        });
    });
  }

  function renderProductSection() {
    return fetch(ROOT + '/?section_id=cart-notification-product')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var inner = sectionInner(html, 'cart-notification-product');
        var prod = document.getElementById('cart-notification-product');
        if (prod) prod.innerHTML = inner;
        return inner;
      });
  }

  // FRI-005 Rollout (10/2026): Warenkorb-Icon öffnet immer das Popup, auch bei leerem Warenkorb
  // (Leer-Zustand mit „Warenkorb schließen“ statt Weiterleitung auf /cart). /cart nur noch als Fallback bei Netzwerkfehler.
  function openFromIcon() {
    renderProductSection()
      .then(function () {
        openNotification();
        scrollCartToTop();
      })
      .catch(function () { window.location.href = CART_URL; });
  }

  function patchCartNotification() {
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('cart-notification').then(function () {
      var CN = customElements.get('cart-notification');
      if (!CN || CN.prototype.__friPatched) return;
      CN.prototype.renderContents = function (parsedState) {
        pinHeader();
        this.cartItemKey = parsedState.key;
        applySections(parsedState.sections);
        if (typeof this.open === 'function') this.open();
        scheduleCartTop();
        scrollCartToTop();
      };
      CN.prototype.__friPatched = true;
    });
  }
  patchCartNotification();

  (function () {
    var note = document.getElementById('cart-notification');
    if (note && window.MutationObserver) {
      new MutationObserver(syncOpenState).observe(note, { attributes: true, attributeFilter: ['class'] });
    }
  })();

  function writeQty(input, qty) { input.value = qty; input.setAttribute('value', qty); }
  function updateLineWash(card, qty) {
    if (!card) return;
    var washEl = card.querySelector('.FRI-66__product-card-wash');
    if (washEl) washEl.textContent = washText(qty, washPerFor(card, null));
  }
  function syncUpsellWash(upsell) {
    var input = upsell.querySelector('.FRI-66__product-card-quantity-input');
    var washEl = upsell.querySelector('.FRI-66__upsell-card-wash-quantity');
    if (input && washEl) washEl.textContent = (parseInt(input.value, 10) || 1) * WASH_PER_UNIT;
  }

  document.addEventListener('click', function (e) {
    var icon = e.target.closest('#cart-icon-bubble');
    if (icon && !icon.closest('#cart-notification')) {
      e.preventDefault(); e.stopPropagation(); openFromIcon(); return;
    }
    var upsell = e.target.closest('.FRI-66__upsell-product-card');
    if (upsell) {
      var uInput = upsell.querySelector('.FRI-66__product-card-quantity-input');
      if (e.target.closest('.FRI-66__product-card-quantity-increment-button')) {
        writeQty(uInput, (parseInt(uInput.value, 10) || 1) + 1); syncUpsellWash(upsell);
      } else if (e.target.closest('.FRI-66__product-card-quantity-decrement-button')) {
        var uv = parseInt(uInput.value, 10) || 1;
        if (uv > 1) { writeQty(uInput, uv - 1); syncUpsellWash(upsell); }
      } else if (e.target.closest('.FRI-66__product-card-hinzufügen-button')) {
        var abtn = e.target.closest('.FRI-66__product-card-hinzufügen-button');
        var variantId = parseInt(abtn.dataset.variantId, 10);
        if (variantId) addVariant(variantId, parseInt(uInput.value, 10) || 1);
      }
      return;
    }
    var card = e.target.closest('.FRI-66__product-card');
    if (card) {
      var key = card.dataset.key;
      var line = card.dataset.line;
      var input = card.querySelector('.FRI-66__product-card-quantity-input');
      var cur = parseInt(input.value, 10) || 1;
      if (e.target.closest('.FRI-66__product-card-quantity-increment-button')) {
        var ni = cur + 1; writeQty(input, ni); updateLineWash(card, ni); changeItem(key, line, ni, true);
      } else if (e.target.closest('.FRI-66__product-card-quantity-decrement-button')) {
        if (cur > 1) { var nd = cur - 1; writeQty(input, nd); updateLineWash(card, nd); changeItem(key, line, nd, true); }
      } else if (e.target.closest('.FRI-66__product-card-delete-from-cart-button')) {
        changeItem(key, line, 0, false);
      }
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('.FRI-66__product-card-quantity-input');
    if (!input) return;
    var qty = parseInt(input.value, 10);
    if (!qty || qty < 1) qty = 1;
    var upsell = input.closest('.FRI-66__upsell-product-card');
    if (upsell) { writeQty(input, qty); syncUpsellWash(upsell); return; }
    var card = input.closest('.FRI-66__product-card');
    if (card) { writeQty(input, qty); updateLineWash(card, qty); changeItem(card.dataset.key, card.dataset.line, qty, true); }
  });

  window.addEventListener('resize', function () {
    if (document.documentElement.classList.contains('fri-cart-open')) syncCartTop();
  });

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    inflight = false; pending = null;
    var note = document.getElementById('cart-notification');
    if (note && note.classList.contains('active')) {
      openLayout();
      renderProductSection().catch(function () {});
    }
  });
})();